var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{style:(_vm.style),attrs:{"disabled":_vm.disabled,"size":_vm.size,"variant":_vm.variant},on:{"click":_vm.emitClick}},[_vm._v(" "+_vm._s(_vm.text)+" "),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }